import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import ProductItemMobile, {ViewMode as ProductItemViewMode} from './ProductItem.Mobile';
import Money from "../../../../../utils/Money";
import {_t} from "../../../../../utils/I18nUtils";
import {useIntl} from "react-intl";
import "./ProductItemsMobile.style.scss";

const ProductItemsMobile = ({vm, products, onProductSelected, hasUsedPromo ,isSelected }) => {

    const [selectedProduct, setSelectedProduct] = useState(null);
    const { locale } = useIntl();
    const lg = locale.split('-')[0];

    if(!products)
        return null;

    return (
        <div className="ProductItemsMobile asButtonsGrid">
            <div>
                {products.map((p) => {
                    return (
                        <ProductItemMobile
                            key={"product"+p.productId}
                            product={p}
                            viewMode={ p.name === "Other" ? ProductItemViewMode.CUSTOM : ProductItemViewMode.AS_BUTTON }
                            onProductSelected={onProductSelected}

                            selectedProduct={selectedProduct}
                            isSelected={ p.productId === vm.selectedProduct?.productId }
                            setSelectedProduct={setSelectedProduct}
                        />
                    );
                })}
            </div>
        </div>
    );
}

ProductItemsMobile.propTypes = {
    products: PropTypes.any,
    onProductSelected: PropTypes.func,
    shortLocale: PropTypes.string
};

export default ProductItemsMobile;